import { useQueryClient } from 'react-query'
import { Button, useModal } from 'app/components'
import { Permission, QUERIES } from '_metronic/helpers'
import { useAuth } from 'app/modules/auth'
import { NotificacaoEnviarModal } from './modal/NotificacaoEnviarModal'

/**
 * Botão "Enviar notificação" (envio manual), usado nas telas de notificações recebidas e
 * enviadas. Só aparece para o SUPER_ADMIN. Ao fechar o modal, atualiza as duas listagens e o
 * contador de não lidas.
 */
export const EnviarNotificacaoButton = () => {
  const { currentUser } = useAuth()
  const { showModal } = useModal()
  const queryClient = useQueryClient()

  if (currentUser?.grupo?.nome !== Permission.SuperAdmin) return null

  const abrirEnvioNotificacao = () =>
    showModal({
      title: 'Enviar notificação',
      content: <NotificacaoEnviarModal />,
      onClose: () => {
        queryClient.invalidateQueries([QUERIES.NOTIFICACOES_LIST])
        queryClient.invalidateQueries([QUERIES.NOTIFICACOES_ENVIADAS_LIST])
        queryClient.invalidateQueries([QUERIES.NOTIFICACOES_NAO_LIDAS_COUNT])
      },
    })

  return (
    <Button variant='secondary-outline' onClick={abrirEnvioNotificacao}>
      Enviar notificação
    </Button>
  )
}
